export default {
  path: '/real',
  meta: {
    title: '实名认证',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/real`),
}



// WEBPACK FOOTER //
// ./src/views/RealNAme/router.js